import {Component, Input} from '@angular/core';
import {UserListItemDto} from "../../../../../pages/users/userslisting/dto/user-list.dto";
import {ITableCellItem} from "../../table-cell";
import {ITableColumn} from "../../table-column";
import {extractSubObjectValue} from "../../table.helpers";

@Component({
    selector: 'app-date-column',
    templateUrl: './date-column.component.html',
    styleUrl: './date-column.component.scss'
})
export class DateColumnComponent implements ITableCellItem {
    @Input() dataItem: UserListItemDto;
    @Input() columnOptions: ITableColumn;
    @Input() dateFormat = 'YYY MMM dd hh:mm:ss';

    get date() {
        return extractSubObjectValue(this.dataItem, this.columnOptions);
    }
}
